import React, { Component, useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { portal_config } from '../../../portal.config';
import Loading from '../../components/Loading';
import { getCurrency, setCurrency, setPaymentRecuring } from '../../utils/common';
import crmservices from '../../wsclient/crmservices';
import WalletView from './WalletView';


function WalletController(props) {
    const { t } = props;
    const [showLoading, setShowLoading] = useState({});
    const [wallet, setWallet] = useState([]);
    const currency = getCurrency() ? getCurrency() : portal_config.default_currency;

    useEffect(() => {
        onLoad();
    }, []);

    const onLoad = async () => {
        setShowLoading(true);
        await onLoadWallet();
        setShowLoading(false);
    }

    const onLoadWallet = async () => {
        try {
            let result = await crmservices.account.getWallet();
            console.log("AAAAAA load wallet:", result);
            if (result.code === 'OK') {
                setWallet(result.data.balances);
            }
        } catch (error) {
            console.log("load contact error:", error);
        }
    }

    return (
        <>
            <WalletView
                currency={currency}
                wallet={wallet}
            />

            {showLoading && <Loading showLoading={showLoading} />}
            
        </>
    );
}

export default (withTranslation()(WalletController));
